import { component } from 'picoapp';
import loadScript from 'utils/load-script';
import waitUntil from 'utils/wait-until';

interface ZendeskConfig {
  zendeskKey: string
}

export default component(async (node) => {
  const config: ZendeskConfig = JSON.parse(node.dataset.config);
  const { zendeskKey } = config;

  const loadZendesk = async () => {
    const url = new URL('https://static.zdassets.com/ekr/snippet.js');
    url.searchParams.append('key', zendeskKey);

    await loadScript(url.toString(), {
      id: 'ze-snippet',
    });

    sessionStorage.setItem('zendesk', 'true');

    await waitUntil(window.zE !== undefined, 200);

    setTimeout(() => {
      window.zE('webWidget', 'setLocale', Shopify.locale);

      window.zE('webWidget:on', 'chat:unreadMessages', () => {
        window.zE('webWidget', 'open');
      });
    }, 200);

    node.remove();
  };

  const initBtn = () => {
    node.hidden = false;

    node.addEventListener('click', async () => {
      node.innerHTML = window.theme.icons.loading;
      if (!sessionStorage.getItem('zendesk')) await loadZendesk();
      window.zE('messenger', 'open');
    });
  };

  const init = async () => {
    if (sessionStorage.getItem('zendesk')) {
      await loadZendesk();
    }

    initBtn();
  };

  init();
});
